import numeral from 'numeral';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { EstimateResponseProps } from 'src/common/api/response';
import { amountFormat } from 'src/common/utils/AmountFormat';
import { Container, LabelValueRow, RegularText, Row } from 'src/components';
import { AppColors } from 'src/themes/Colors';
import { metrics } from 'src/themes/Metrics';

export const PaymentBreakdown = ({ estimation }: { estimation?: EstimateResponseProps }) => {
  const { t } = useTranslation();

  return (
    <Container
      style={{
        borderBottomWidth: 1,
        borderColor: AppColors.border,
        marginBottom: metrics.medium,
        paddingBottom: metrics.medium,
      }}>
      <CustomLabelValueRow
        label={t('departureTrip')}
        subtotal={amountFormat(estimation?.mainTripSubtotal)}
        promotionDiscount={estimation?.mainTripPromotionDiscount || 0}
        total={amountFormat(
          numeral(estimation?.mainTripSubtotal).subtract(estimation?.mainTripPromotionDiscount).value(),
        )}
      />
      {estimation?.returnTripSubtotal === 0 ? null : (
        <CustomLabelValueRow
          label={t('returnTrip')}
          subtotal={amountFormat(estimation?.returnTripSubtotal)}
          promotionDiscount={estimation?.returnTripPromotionDiscount || 0}
          total={amountFormat(
            numeral(estimation?.returnTripSubtotal).subtract(estimation?.returnTripPromotionDiscount).value(),
          )}
        />
      )}
      {estimation?.couponDiscount !== 0 && (
        <LabelValueRow color={AppColors.red} label={t('coupon')} value={amountFormat(estimation?.couponDiscount)} />
      )}

      {/* {discount ? <LabelValueRow label={t('discount')} value={amountFormat(discount)} /> : <View />}
      {coupon ? (
        <LabelValueRow
          label={t('couponUsed')}`
          value={
            <Row middle>
              <IconSvg.CouponSmall />
              <SizedBox width="medium" />
              <RegularText>{coupon}</RegularText>
            </Row>
          }
        />
      ) : (
        <View />
      )} */}
    </Container>
  );
};

const CustomLabelValueRow = ({
  label,
  promotionDiscount,
  subtotal,
  total,
}: {
  label: string;
  promotionDiscount: number;
  subtotal: string;
  total: string;
}) => {
  return (
    <LabelValueRow
      label={label}
      value={
        <Row center>
          {promotionDiscount !== 0 && (
            <RegularText
              style={{ marginRight: metrics.small, textDecorationLine: 'line-through' }}
              fontSize="medium"
              color={AppColors.red}
              fontWeight="bold">
              {subtotal}
            </RegularText>
          )}
          <RegularText>{total}</RegularText>
        </Row>
      }
    />
  );
};
